/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfListOfContactNameDto } from '../models/custom-result-of-list-of-contact-name-dto';
import { CustomResultOfListOfCurrentOrganizationPhonebooksDto } from '../models/custom-result-of-list-of-current-organization-phonebooks-dto';
import { CustomResultOfListOfCurrentOrganizationPhonebooksDto2 } from '../models/custom-result-of-list-of-current-organization-phonebooks-dto-2';
import { CustomResultOfListOfPhonebookDto } from '../models/custom-result-of-list-of-phonebook-dto';
import { CustomResultOfListOfPhonebooksByContactIdDto } from '../models/custom-result-of-list-of-phonebooks-by-contact-id-dto';
import { CustomResultOfListOfPhonebooksListByOrganizationIdDto } from '../models/custom-result-of-list-of-phonebooks-list-by-organization-id-dto';
import { CustomResultOfListOfPhonebooksListForServicesDto } from '../models/custom-result-of-list-of-phonebooks-list-for-services-dto';
import { CustomResultOfPaginatedListOfGetPhonebookRecipientByScheduledMessageIdDto } from '../models/custom-result-of-paginated-list-of-get-phonebook-recipient-by-scheduled-message-id-dto';
import { CustomResultOfPaginatedListOfPhonebookDto } from '../models/custom-result-of-paginated-list-of-phonebook-dto';
import { CustomResultOfPhonebookByIdDto } from '../models/custom-result-of-phonebook-by-id-dto';
import { phonebooksCreateGet } from '../fn/phonebooks/phonebooks-create-get';
import { PhonebooksCreateGet$Params } from '../fn/phonebooks/phonebooks-create-get';
import { phonebooksCreatePost } from '../fn/phonebooks/phonebooks-create-post';
import { PhonebooksCreatePost$Params } from '../fn/phonebooks/phonebooks-create-post';
import { phonebooksDelete } from '../fn/phonebooks/phonebooks-delete';
import { PhonebooksDelete$Params } from '../fn/phonebooks/phonebooks-delete';
import { phonebooksDeleteManyByIdList } from '../fn/phonebooks/phonebooks-delete-many-by-id-list';
import { PhonebooksDeleteManyByIdList$Params } from '../fn/phonebooks/phonebooks-delete-many-by-id-list';
import { phonebooksGetAllFieldsByPhonebookId } from '../fn/phonebooks/phonebooks-get-all-fields-by-phonebook-id';
import { PhonebooksGetAllFieldsByPhonebookId$Params } from '../fn/phonebooks/phonebooks-get-all-fields-by-phonebook-id';
import { phonebooksGetCurrentOrganizationPhonebooksList } from '../fn/phonebooks/phonebooks-get-current-organization-phonebooks-list';
import { PhonebooksGetCurrentOrganizationPhonebooksList$Params } from '../fn/phonebooks/phonebooks-get-current-organization-phonebooks-list';
import { phonebooksGetDescendantPhonebooksWithPagination } from '../fn/phonebooks/phonebooks-get-descendant-phonebooks-with-pagination';
import { PhonebooksGetDescendantPhonebooksWithPagination$Params } from '../fn/phonebooks/phonebooks-get-descendant-phonebooks-with-pagination';
import { phonebooksGetPhonebookRecipientByScheduledMessageId } from '../fn/phonebooks/phonebooks-get-phonebook-recipient-by-scheduled-message-id';
import { PhonebooksGetPhonebookRecipientByScheduledMessageId$Params } from '../fn/phonebooks/phonebooks-get-phonebook-recipient-by-scheduled-message-id';
import { phonebooksGetPhonebooksAuditWithPagination } from '../fn/phonebooks/phonebooks-get-phonebooks-audit-with-pagination';
import { PhonebooksGetPhonebooksAuditWithPagination$Params } from '../fn/phonebooks/phonebooks-get-phonebooks-audit-with-pagination';
import { phonebooksGetPhonebooksByContactsId } from '../fn/phonebooks/phonebooks-get-phonebooks-by-contacts-id';
import { PhonebooksGetPhonebooksByContactsId$Params } from '../fn/phonebooks/phonebooks-get-phonebooks-by-contacts-id';
import { phonebooksGetPhonebooksByParentId } from '../fn/phonebooks/phonebooks-get-phonebooks-by-parent-id';
import { PhonebooksGetPhonebooksByParentId$Params } from '../fn/phonebooks/phonebooks-get-phonebooks-by-parent-id';
import { phonebooksGetPhonebooksForDevicesByOrganizationId } from '../fn/phonebooks/phonebooks-get-phonebooks-for-devices-by-organization-id';
import { PhonebooksGetPhonebooksForDevicesByOrganizationId$Params } from '../fn/phonebooks/phonebooks-get-phonebooks-for-devices-by-organization-id';
import { phonebooksGetPhonebooksListByOrganizationId } from '../fn/phonebooks/phonebooks-get-phonebooks-list-by-organization-id';
import { PhonebooksGetPhonebooksListByOrganizationId$Params } from '../fn/phonebooks/phonebooks-get-phonebooks-list-by-organization-id';
import { phonebooksGetPhonebooksListForServices } from '../fn/phonebooks/phonebooks-get-phonebooks-list-for-services';
import { PhonebooksGetPhonebooksListForServices$Params } from '../fn/phonebooks/phonebooks-get-phonebooks-list-for-services';
import { phonebooksGetPhonebooksWithPagination } from '../fn/phonebooks/phonebooks-get-phonebooks-with-pagination';
import { PhonebooksGetPhonebooksWithPagination$Params } from '../fn/phonebooks/phonebooks-get-phonebooks-with-pagination';
import { phonebooksShowPhonebooksWithPagination } from '../fn/phonebooks/phonebooks-show-phonebooks-with-pagination';
import { PhonebooksShowPhonebooksWithPagination$Params } from '../fn/phonebooks/phonebooks-show-phonebooks-with-pagination';
import { phonebooksUpdateGet } from '../fn/phonebooks/phonebooks-update-get';
import { PhonebooksUpdateGet$Params } from '../fn/phonebooks/phonebooks-update-get';
import { phonebooksUpdatePut } from '../fn/phonebooks/phonebooks-update-put';
import { PhonebooksUpdatePut$Params } from '../fn/phonebooks/phonebooks-update-put';

@Injectable({ providedIn: 'root' })
export class PhonebooksService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `phonebooksCreateGet()` */
  static readonly PhonebooksCreateGetPath = '/Phonebooks/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksCreateGet$Response(params?: PhonebooksCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return phonebooksCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksCreateGet(params?: PhonebooksCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.phonebooksCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `phonebooksCreatePost()` */
  static readonly PhonebooksCreatePostPath = '/Phonebooks/Create';

  /**
   * Create Phonebook.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksCreatePost$Response(params: PhonebooksCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return phonebooksCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Phonebook.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksCreatePost(params: PhonebooksCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.phonebooksCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `phonebooksDelete()` */
  static readonly PhonebooksDeletePath = '/Phonebooks';

  /**
   * Delete Phonebook.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksDelete$Response(params: PhonebooksDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return phonebooksDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Phonebook.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksDelete(params: PhonebooksDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.phonebooksDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `phonebooksDeleteManyByIdList()` */
  static readonly PhonebooksDeleteManyByIdListPath = '/Phonebooks/DeleteManyByIdList';

  /**
   * Delete Phonebook List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksDeleteManyByIdList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksDeleteManyByIdList$Response(params: PhonebooksDeleteManyByIdList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return phonebooksDeleteManyByIdList(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Phonebook List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksDeleteManyByIdList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksDeleteManyByIdList(params: PhonebooksDeleteManyByIdList$Params, context?: HttpContext): Observable<CustomResult> {
    return this.phonebooksDeleteManyByIdList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `phonebooksUpdatePut()` */
  static readonly PhonebooksUpdatePutPath = '/Phonebooks/Update';

  /**
   * Update Phonebook.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksUpdatePut$Response(params: PhonebooksUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return phonebooksUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Phonebook.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksUpdatePut(params: PhonebooksUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.phonebooksUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `phonebooksUpdateGet()` */
  static readonly PhonebooksUpdateGetPath = '/Phonebooks/Update/{id}';

  /**
   * Get phonebook by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksUpdateGet$Response(params: PhonebooksUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPhonebookByIdDto>> {
    return phonebooksUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get phonebook by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksUpdateGet(params: PhonebooksUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfPhonebookByIdDto> {
    return this.phonebooksUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPhonebookByIdDto>): CustomResultOfPhonebookByIdDto => r.body)
    );
  }

  /** Path part for operation `phonebooksGetPhonebooksWithPagination()` */
  static readonly PhonebooksGetPhonebooksWithPaginationPath = '/Phonebooks/GetPhonebooksWithPagination';

  /**
   * For each user get phonebooks with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksGetPhonebooksWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksGetPhonebooksWithPagination$Response(params: PhonebooksGetPhonebooksWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfPhonebookDto>> {
    return phonebooksGetPhonebooksWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get phonebooks with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksGetPhonebooksWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksGetPhonebooksWithPagination(params: PhonebooksGetPhonebooksWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfPhonebookDto> {
    return this.phonebooksGetPhonebooksWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfPhonebookDto>): CustomResultOfPaginatedListOfPhonebookDto => r.body)
    );
  }

  /** Path part for operation `phonebooksGetDescendantPhonebooksWithPagination()` */
  static readonly PhonebooksGetDescendantPhonebooksWithPaginationPath = '/Phonebooks/GetDescendantPhonebooksWithPagination';

  /**
   * For each user get phonebooks with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksGetDescendantPhonebooksWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksGetDescendantPhonebooksWithPagination$Response(params: PhonebooksGetDescendantPhonebooksWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfPhonebookDto>> {
    return phonebooksGetDescendantPhonebooksWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get phonebooks with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksGetDescendantPhonebooksWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksGetDescendantPhonebooksWithPagination(params: PhonebooksGetDescendantPhonebooksWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfPhonebookDto> {
    return this.phonebooksGetDescendantPhonebooksWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfPhonebookDto>): CustomResultOfPaginatedListOfPhonebookDto => r.body)
    );
  }

  /** Path part for operation `phonebooksShowPhonebooksWithPagination()` */
  static readonly PhonebooksShowPhonebooksWithPaginationPath = '/Phonebooks/ShowPhonebooksWithPagination';

  /**
   * نمایش دفترتلفن ها با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksShowPhonebooksWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksShowPhonebooksWithPagination$Response(params: PhonebooksShowPhonebooksWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfPhonebookDto>> {
    return phonebooksShowPhonebooksWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * نمایش دفترتلفن ها با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksShowPhonebooksWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksShowPhonebooksWithPagination(params: PhonebooksShowPhonebooksWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfPhonebookDto> {
    return this.phonebooksShowPhonebooksWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfPhonebookDto>): CustomResultOfPaginatedListOfPhonebookDto => r.body)
    );
  }

  /** Path part for operation `phonebooksGetPhonebooksByParentId()` */
  static readonly PhonebooksGetPhonebooksByParentIdPath = '/Phonebooks/GetPhonebooksByParentId';

  /**
   * دریافت دفترتلفن ها بر اساس شناسه والد.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksGetPhonebooksByParentId()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksGetPhonebooksByParentId$Response(params?: PhonebooksGetPhonebooksByParentId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfPhonebookDto>> {
    return phonebooksGetPhonebooksByParentId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت دفترتلفن ها بر اساس شناسه والد.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksGetPhonebooksByParentId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksGetPhonebooksByParentId(params?: PhonebooksGetPhonebooksByParentId$Params, context?: HttpContext): Observable<CustomResultOfListOfPhonebookDto> {
    return this.phonebooksGetPhonebooksByParentId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfPhonebookDto>): CustomResultOfListOfPhonebookDto => r.body)
    );
  }

  /** Path part for operation `phonebooksGetPhonebooksAuditWithPagination()` */
  static readonly PhonebooksGetPhonebooksAuditWithPaginationPath = '/Phonebooks/GetPhonebooksAuditWithPagination';

  /**
   * Get Phonebook Audit With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksGetPhonebooksAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksGetPhonebooksAuditWithPagination$Response(params: PhonebooksGetPhonebooksAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return phonebooksGetPhonebooksAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Phonebook Audit With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksGetPhonebooksAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksGetPhonebooksAuditWithPagination(params: PhonebooksGetPhonebooksAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.phonebooksGetPhonebooksAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `phonebooksGetPhonebookRecipientByScheduledMessageId()` */
  static readonly PhonebooksGetPhonebookRecipientByScheduledMessageIdPath = '/Phonebooks/GetPhonebookRecipientByScheduledMessageId';

  /**
   * Get Phonebook Recipient By Scheduled Message Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksGetPhonebookRecipientByScheduledMessageId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksGetPhonebookRecipientByScheduledMessageId$Response(params: PhonebooksGetPhonebookRecipientByScheduledMessageId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetPhonebookRecipientByScheduledMessageIdDto>> {
    return phonebooksGetPhonebookRecipientByScheduledMessageId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Phonebook Recipient By Scheduled Message Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksGetPhonebookRecipientByScheduledMessageId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksGetPhonebookRecipientByScheduledMessageId(params: PhonebooksGetPhonebookRecipientByScheduledMessageId$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetPhonebookRecipientByScheduledMessageIdDto> {
    return this.phonebooksGetPhonebookRecipientByScheduledMessageId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetPhonebookRecipientByScheduledMessageIdDto>): CustomResultOfPaginatedListOfGetPhonebookRecipientByScheduledMessageIdDto => r.body)
    );
  }

  /** Path part for operation `phonebooksGetAllFieldsByPhonebookId()` */
  static readonly PhonebooksGetAllFieldsByPhonebookIdPath = '/Phonebooks/GetAllFieldsByPhonebookId';

  /**
   * Get All Fields By Phonebook Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksGetAllFieldsByPhonebookId()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksGetAllFieldsByPhonebookId$Response(params?: PhonebooksGetAllFieldsByPhonebookId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfContactNameDto>> {
    return phonebooksGetAllFieldsByPhonebookId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Fields By Phonebook Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksGetAllFieldsByPhonebookId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksGetAllFieldsByPhonebookId(params?: PhonebooksGetAllFieldsByPhonebookId$Params, context?: HttpContext): Observable<CustomResultOfListOfContactNameDto> {
    return this.phonebooksGetAllFieldsByPhonebookId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfContactNameDto>): CustomResultOfListOfContactNameDto => r.body)
    );
  }

  /** Path part for operation `phonebooksGetPhonebooksByContactsId()` */
  static readonly PhonebooksGetPhonebooksByContactsIdPath = '/Phonebooks/GetPhonebooksByContactsId';

  /**
   * Get Phonebooks By Contacts Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksGetPhonebooksByContactsId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksGetPhonebooksByContactsId$Response(params: PhonebooksGetPhonebooksByContactsId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfPhonebooksByContactIdDto>> {
    return phonebooksGetPhonebooksByContactsId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Phonebooks By Contacts Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksGetPhonebooksByContactsId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonebooksGetPhonebooksByContactsId(params: PhonebooksGetPhonebooksByContactsId$Params, context?: HttpContext): Observable<CustomResultOfListOfPhonebooksByContactIdDto> {
    return this.phonebooksGetPhonebooksByContactsId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfPhonebooksByContactIdDto>): CustomResultOfListOfPhonebooksByContactIdDto => r.body)
    );
  }

  /** Path part for operation `phonebooksGetCurrentOrganizationPhonebooksList()` */
  static readonly PhonebooksGetCurrentOrganizationPhonebooksListPath = '/Phonebooks/GetCurrentOrganizationPhonebooksList';

  /**
   * Get CurrentOrganization Phonebooks List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksGetCurrentOrganizationPhonebooksList()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksGetCurrentOrganizationPhonebooksList$Response(params?: PhonebooksGetCurrentOrganizationPhonebooksList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfCurrentOrganizationPhonebooksDto>> {
    return phonebooksGetCurrentOrganizationPhonebooksList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get CurrentOrganization Phonebooks List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksGetCurrentOrganizationPhonebooksList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksGetCurrentOrganizationPhonebooksList(params?: PhonebooksGetCurrentOrganizationPhonebooksList$Params, context?: HttpContext): Observable<CustomResultOfListOfCurrentOrganizationPhonebooksDto> {
    return this.phonebooksGetCurrentOrganizationPhonebooksList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfCurrentOrganizationPhonebooksDto>): CustomResultOfListOfCurrentOrganizationPhonebooksDto => r.body)
    );
  }

  /** Path part for operation `phonebooksGetPhonebooksForDevicesByOrganizationId()` */
  static readonly PhonebooksGetPhonebooksForDevicesByOrganizationIdPath = '/Phonebooks/GetPhonebooksForDevicesByOrganizationId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksGetPhonebooksForDevicesByOrganizationId()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksGetPhonebooksForDevicesByOrganizationId$Response(params?: PhonebooksGetPhonebooksForDevicesByOrganizationId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfCurrentOrganizationPhonebooksDto2>> {
    return phonebooksGetPhonebooksForDevicesByOrganizationId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksGetPhonebooksForDevicesByOrganizationId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksGetPhonebooksForDevicesByOrganizationId(params?: PhonebooksGetPhonebooksForDevicesByOrganizationId$Params, context?: HttpContext): Observable<CustomResultOfListOfCurrentOrganizationPhonebooksDto2> {
    return this.phonebooksGetPhonebooksForDevicesByOrganizationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfCurrentOrganizationPhonebooksDto2>): CustomResultOfListOfCurrentOrganizationPhonebooksDto2 => r.body)
    );
  }

  /** Path part for operation `phonebooksGetPhonebooksListForServices()` */
  static readonly PhonebooksGetPhonebooksListForServicesPath = '/Phonebooks/GetPhonebooksListForServices';

  /**
   * دریافت لیست دفترتلفن ها برای سرویس ها (تحلیلگر،مسابقه و نظرسنجی).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksGetPhonebooksListForServices()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksGetPhonebooksListForServices$Response(params?: PhonebooksGetPhonebooksListForServices$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfPhonebooksListForServicesDto>> {
    return phonebooksGetPhonebooksListForServices(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست دفترتلفن ها برای سرویس ها (تحلیلگر،مسابقه و نظرسنجی).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksGetPhonebooksListForServices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksGetPhonebooksListForServices(params?: PhonebooksGetPhonebooksListForServices$Params, context?: HttpContext): Observable<CustomResultOfListOfPhonebooksListForServicesDto> {
    return this.phonebooksGetPhonebooksListForServices$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfPhonebooksListForServicesDto>): CustomResultOfListOfPhonebooksListForServicesDto => r.body)
    );
  }

  /** Path part for operation `phonebooksGetPhonebooksListByOrganizationId()` */
  static readonly PhonebooksGetPhonebooksListByOrganizationIdPath = '/Phonebooks/GetPhonebooksListByOrganizationId';

  /**
   * دریافت لیست دفترتلفن ها بر اساس شناسه سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonebooksGetPhonebooksListByOrganizationId()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksGetPhonebooksListByOrganizationId$Response(params?: PhonebooksGetPhonebooksListByOrganizationId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfPhonebooksListByOrganizationIdDto>> {
    return phonebooksGetPhonebooksListByOrganizationId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست دفترتلفن ها بر اساس شناسه سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonebooksGetPhonebooksListByOrganizationId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonebooksGetPhonebooksListByOrganizationId(params?: PhonebooksGetPhonebooksListByOrganizationId$Params, context?: HttpContext): Observable<CustomResultOfListOfPhonebooksListByOrganizationIdDto> {
    return this.phonebooksGetPhonebooksListByOrganizationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfPhonebooksListByOrganizationIdDto>): CustomResultOfListOfPhonebooksListByOrganizationIdDto => r.body)
    );
  }

}
